module.exports = __webpack_public_path__ + "img/check_04.f79e0002.png";